import React, { useState } from 'react';
import { Link, Typography } from '@mui/material';
import { AlTextField } from '../../../common/components/AlTextField';
import { FormActions } from '../FormActions/FormActions';
import { useTranslation } from 'react-i18next';
import { checkRequired } from '../../../common/utils/validation';
import { AuthService } from '../../../api/AuthService';

const LoginForm = ({ setUser, onCancel, notifications, onReset, onSignup }) => {
    const { t } = useTranslation();
    const [busy, setBusy] = useState(false);
    const [login, setLogin] = useState('');
    const [loginTouched, setLoginTouched] = useState(false);
    const isLoginError = checkRequired(login) && loginTouched;
    const [password, setPassword] = useState('');
    const [passwordTouched, setPasswordTouched] = useState(false);
    const isPasswordError = checkRequired(password) && passwordTouched;
    const isValid = !checkRequired(login) && !checkRequired(password);

    const onLogin = (e) => {
        e.stopPropagation();
        e.preventDefault();

        setBusy(true);
        notifications.clearError();
        AuthService.login({ login, password })
            .then((responseUser) => {
                setUser(responseUser);
                onCancel();
            })
            .catch((error) => {
                notifications.showError(error.response?.data);
                setBusy(false);
            });
    };

    return (
        <form noValidate autoComplete="off" onSubmit={onLogin} data-cy="loginForm">
            <AlTextField
                fullWidth
                autoFocus
                placeholder={t('placeholder.login')}
                onChange={(e) => setLogin(e.target.value)}
                onBlur={() => setLoginTouched(true)}
                error={isLoginError}
                value={login}
                required={true}
                sx={{ mb: 1.5 }}
                disabled={busy}
                alTooltip={t('tooltip.resetForm.login')}
                name={'login'}
            />
            <AlTextField
                fullWidth
                placeholder={t('placeholder.password')}
                onChange={(e) => setPassword(e.target.value)}
                onBlur={() => setPasswordTouched(true)}
                error={isPasswordError}
                value={password}
                required={true}
                sx={{ mb: 2 }}
                disabled={busy}
                type="password"
                name={'password'}
            />
            <FormActions onCancel={onCancel} submitLabel={t('button.login')} busy={busy} submitDisabled={!isValid} />
            <Typography variant="body2" sx={{ mt: 2, textAlign: 'center' }}>
                <Link component="button" type="button" onClick={onReset}>
                    {t('button.resetPassword')}
                </Link>
            </Typography>
            <Typography variant="body2" sx={{ mt: 1, textAlign: 'center' }}>
                {t('loginForm.noAccountText')}{' '}
                <Link component="button" type="button" onClick={onSignup}>
                    {t('loginForm.noAccountLink')}
                </Link>
            </Typography>
        </form>
    );
};

export { LoginForm };
